import client from "@/lib/api/apolloClient.ts";
import {
  GQL_BULK_DELETE_SCHEDULED_REPORTS,
  GQL_DELETE_SCHEDULED_REPORT,
  GQL_SCHEDULED_REPORTS,
} from "@/lib/queries/reports.ts";
import {MutationStatusResponse} from "@/lib/types/common.ts";

export const deleteScheduledReport = async (id: number) => {
  return await client.mutate<MutationStatusResponse>({
    mutation: GQL_DELETE_SCHEDULED_REPORT,
    variables: {id},
    refetchQueries: [GQL_SCHEDULED_REPORTS],
  });
};

export const bulkDeleteScheduledReports = async (ids: number[]) => {
  return await client.mutate<MutationStatusResponse>({
    mutation: GQL_BULK_DELETE_SCHEDULED_REPORTS,
    variables: {ids},
    refetchQueries: [GQL_SCHEDULED_REPORTS],
  });
};
